import { B as BxfIconTypeEnum } from './bxf-icon.type-4afcd2ad.js';

const SPIN_ANIMATION = 'spin 1s linear infinite';
const BXF_ICON_CONTAINER = 'bxf-icon__container';
const BXF_ICON_CONTAINER_NO_CURSOR = 'bxf-icon__container--cursor-disabled';
const DISABLED = 'disabled';
const UNDERLINE_HOVER = 'bxf-icon__container--underline-hover';
const BXF_ICON_STROKE = 'bxf-icon__stroke';
const BXF_ICON_FILL = 'bxf-icon__fill';
const BXF_ICON_WITH_TEXT = '-inverted';
// stroke should be filled, fill should be transparent
const ICONS_STROKE_STYLING = new Set([
    'add',
    'alert-subtle',
    'alert-subtle-large',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'bookmark-subtle',
    'buy',
    'checkmark',
    'data-custom-sort',
    'data-filter-a-z',
    'data-filter-large-small',
    'data-filter-small-large',
    'data-filter-z-a',
    'data-select-arrow-down',
    'data-select-arrow-up',
    'did-not-run',
    'favorite-subtle',
    'filter-subtle',
    'help-subtle',
    'info-subtle',
    'info-subtle-large',
    'inprogress-2',
    'inprogress-subtle',
    'inprogress-subtle-large',
    'log-in',
    'log-out',
    'new-subtle',
    'new-subtle-large',
    'play',
    'progress-empty',
    'progress-empty-large',
    'sell',
    'success-subtle',
    'success-subtle-large',
    'unlock',
    'upload',
    'uploader-32',
    'uploader-68',
    'zoom-in',
    'zoom-out',
    'bxf-logo-large',
]);
// fill and stroke should be filled
const ICONS_STROKE_FILL_STYLING = new Set([
    'alert-subtle',
    'alert-subtle-large',
    'buy',
    'data-custom-sort',
    'data-filter-a-z',
    'data-filter-z-a',
    'delete',
    'delete-small',
    'did-not-run',
    'help-subtle',
    'info-subtle',
    'info-subtle-large',
    'log-in',
    'log-out',
    'new-subtle',
    'new-subtle-large',
    'sell',
    'unlock',
    'upload',
    'uploader-32',
    'uploader-68',
    'bxf-arrow-right',
    'bxf-chat-blk-beta',
    'bxf-beta',
    'bxf-send',
    'bxf-kebab-menu',
    'bxf-stop',
    'bxf-chat',
    'bxf-clear',
    'bxf-contact',
    'bxf-copy',
    'bxf-history',
    'bxf-new-chat',
    'bxf-email',
    'bxf-phone',
    'bxf-calendar',
    'bxf-sparkle',
    'bxf-thumbs-down',
    'bxf-thumbs-up',
    'bxf-sparkle-large',
    'bxf-close',
    'bxf-caution48',
]);
// icons with custom svg sizes (svg width and height are not equal 16px)
const CUSTOM_ICON_SIZES = {
    lightbulb: 1.5,
    'action-12': 0.75,
    'alert-bold-large': 1.5,
    'alert-subtle-large': 1.5,
    'favorite-bold-32': 2,
    'info-bold-large': 1.5,
    'info-subtle-large': 1.5,
    'inprogress-bold-large': 1.5,
    'inprogress-subtle-large': 1.5,
    'new-bold-large': 1.5,
    'new-subtle-large': 1.5,
    'progress-active-large': 1.5,
    'progress-empty-large': 1.5,
    'success-bold-large': 1.5,
    'success-subtle-large': 1.5,
    'uploader-32': 2,
    'uploader-68': 4.25,
    'widget-size-expand-grow': 1.0625,
    'copilot-20': 1.25,
    'copilot-32': 2,
    'copilot-64': 4,
    'bxf-arrow-right': 1.125,
    'bxf-chat-blk-beta': 6.875,
    'bxf-loading': 3.5,
    'bxf-loading48': 3,
    'bxf-chat': 3.5,
    'bxf-clear': 1.125,
    'bxf-contact': 2,
    'bxf-dismiss': 2,
    'bxf-history': 2,
    'bxf-kebab-menu': 0.75,
    'bxf-nav-active': 1.5,
    'bxf-nav-inactive': 1.5,
    'bxf-new-chat': 2.438,
    'bxf-email': 0.875,
    'bxf-phone': 1,
    'bxf-panel-logo': 14.75,
    'bxf-calendar': 1,
    'bxf-sparkle': 1.5,
    'bxf-sparkle-large': 2.8125,
    'bxf-thumbs-down': 1.25,
    'bxf-thumbs-up': 1.25,
    'bxf-logo-large': 23.375,
    'bxf-beta': 2.625,
    'bxf-stop': 1.5,
    'bxf-caution48': 3,
    'bxf-pdf': 1.75,
    'bxf-full-screen': 2,
    'bxf-exit-full-screen': 2,
};
const CUSTOM_ICON_HEIGHT = {
    'bxf-arrow-right': 1.125,
    'bxf-chat-blk-beta': 2.75,
    'bxf-loading': 2,
    'bxf-loading48': 3,
    'bxf-chat': 2,
    'bxf-clear': 1.25,
    'bxf-contact': 2,
    'bxf-copy': 1.063,
    'bxf-email': 0.625,
    'bxf-phone': 1,
    'bxf-panel-logo': 3.375,
    'bxf-calendar': 0.875,
    'bxf-dismiss': 2.125,
    'bxf-history': 2,
    'bxf-kebab-menu': 1.3125,
    'bxf-nav-active': 1.5,
    'bxf-nav-inactive': 1.5,
    'bxf-new-chat': 2,
    'bxf-sparkle': 1.5,
    'bxf-sparkle-large': 2.8125,
    'bxf-thumbs-down': 1.313,
    'bxf-thumbs-up': 1.313,
    'bxf-logo-large': 6.625,
    'bxf-stop': 1.5,
    'bxf-caution48': 3,
    'bxf-pdf': 1.5,
    'bxf-full-screen': 2,
    'bxf-exit-full-screen': 2,
};
// icon which should have spin animation by default
const ICONS_WITH_SPIN = new Set([
    BxfIconTypeEnum['loading'],
]);
const BXF_ICON_LOADING = new Set([
    BxfIconTypeEnum['bxf-loading'],
    BxfIconTypeEnum['bxf-loading48'],
]);
const BXF_ICON_UNDERLINE = new Set([
    BxfIconTypeEnum['bxf-thumbs-up'],
    BxfIconTypeEnum['bxf-thumbs-down'],
]);

export { BXF_ICON_CONTAINER as B, CUSTOM_ICON_SIZES as C, DISABLED as D, ICONS_STROKE_STYLING as I, SPIN_ANIMATION as S, UNDERLINE_HOVER as U, BXF_ICON_CONTAINER_NO_CURSOR as a, BXF_ICON_STROKE as b, BXF_ICON_FILL as c, BXF_ICON_WITH_TEXT as d, ICONS_STROKE_FILL_STYLING as e, CUSTOM_ICON_HEIGHT as f, ICONS_WITH_SPIN as g, BXF_ICON_LOADING as h, BXF_ICON_UNDERLINE as i };
